import { removeAccents } from '@utils/Format'

/**
 * Simplificação de filtro por texto
 * @param {Array} list Lista a ser filtrada
 * @param {String|Array<String>} attr Atributo para considerar no filtro
 * @param {Any} value Valor a ser filtrado
 */
export const filter = (list, attr, value) => {
  return [...list].filter((v, i) => {
    if (typeof attr === 'string') {
      if (typeof value === 'string') {
        return removeAccents(
          ((attr ? v[attr] : v) || '').trim().toLowerCase()
        ).includes(removeAccents((value || '').trim().toLowerCase()))
      } else {
        return (attr ? v[attr] : v) === value
      }
    } else if (typeof attr === 'object' && attr.length) {
      return attr.some((a) => {
        return removeAccents((v[a] || '').trim().toLowerCase()).includes(
          removeAccents((value || '').trim().toLowerCase())
        )
      })
    }
  })
}

export default {
  filter,
}
